export function applyFilterOption(filter) {
  for (const element of document.querySelectorAll(".yxt-FilterOptions-optionLabel--name")) {
    if (element.textContent.trim() === filter.trim()) {
      element.parentElement.click();
    }
  }
}